import React from 'react';
import { NotificationContext } from '../components';

export const useNotification = () => {
    return React.useContext(NotificationContext);
};
